<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />

  <h4>Habilitar manualmente</h4>

  <div class="row" style="margin-top: 15px">
    <div class="col-md-12">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label for="exampleInputEmail1">Leilão ID</label>
            <input class="form-control" id="leilao_id" v-model="formData.leilao_id" />

            <span style="color: red" v-for="error in v$.leilao_id.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="form-group">
            <label for="exampleInputEmail1">Status</label>

            <select class="custom-select rounded-0" v-model="formData.status">
              <option value="bloqueado">Bloqueado</option>
              <option value="liberado">Liberado</option>
              <option value="aguardando">Aguardando</option>
            </select>

            <span style="color: red" v-for="error in v$.status.$errors" :key="error.$uid">
              {{ error.$message }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="card-footer" style="width: 100%">
      <button type="submit" class="btn btn-primary" @click="store()">Salvar</button>
      <a id="close_editar" data-dismiss="modal" @click="close" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
    </div>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";

import useVueLidate from "@vuelidate/core";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["user", "closeModal", "acaoRealizada"],

  components: { Loading },

  data() {
    return {
      isLoading: false,
    };
  },

  setup() {
    const formData = reactive({
      leilao_id: "",
      status: "liberado",
    });

    const rules = computed(() => {
      return {
        leilao_id: { required },
        status: { required },
      };
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {},

  methods: {
    close() {
      let btn = document.getElementById("close_editar");
      btn.click();

      this.closeModal();
    },

    async store() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        let data = {
          user_id: this.user.id,
          leilao_id: this.formData.leilao_id,
          status: this.formData.status,
        };

        console.log("Cadastrando");
        console.log(data);

        axios
          .post(`/admin/habilitacoes/habilitar_manualmente`, data)
          .then((response) => {
            this.isLoading = false;

            if (response.data.success) {
              let btn = document.getElementById("close_editar");
              btn.click();

              this.showSuccessMessageWithButton("Sucesso", "Habilitação cadastrada!");
              this.acaoRealizada("cadastrar_habilitacao");
            } else {
              this.showErrorMessageWithButton("Ops...", response.data.msg);
            }
          })
          .catch((error) => {
            this.isLoading = false;
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      }
    },
  },
};
</script>
